<template>
    <div>
        <div class="titre contour_texte_carte">Localisations</div>
        <div class="legendes">
            <div class="legende contour_texte_carte" 
                v-for="categorie in categories"
                :key="categorie.slug"
                @click="filtrer(categorie.slug)"
                :class="{filtre_actif: categorie.actif && !toutes_categories_affichees}">
                <div class="marqueur_legende" :class="categorie.slug"></div>
                <span v-html="categorie.nom+'&nbsp;('+categorie.nombre+')'"></span>
            </div>
        </div>
        <div class="container_volet localisations">
            <div id='carte'>
                <div id="map-caption-box"></div>
            </div>
        </div>
    </div>
</template>


<script>
import mapboxgl from 'mapbox-gl'; // or "const mapboxgl = require('mapbox-gl');"
import { state } from '../../main.js';
import { url_base } from '../../variables.js';

var map;
var marqueurs = [];

export default {
    data() {
        return {
            fiches: state.fiches,
            toutes_categories_affichees: true,
            categories: [{
                    "slug": "transformation_spatiale",
                    "nom": "Transformations<br>spatiales",
                    "nombre": 0,
                    "actif": true
                },
                {
                    "slug": "recherche_et_publication",
                    "nom": "Recherches et<br>publications",
                    "nombre": 0,
                    "actif": true
                },
                {
                    "slug": "action_sociale_et_artistique",
                    "nom": "Actions sociales<br>et artistiques",
                    "nombre": 0,
                    "actif": true
                },
                {
                    "slug": "plateforme_et_collectif",
                    "nom": "Plateformes<br>et collectifs",
                    "nombre": 0,
                    "actif": true
                },
                {
                    "slug": "exp_rience_p_dagogique",
                    "nom": "Expériences<br>pédagogiques",
                    "nombre": 0,
                    "actif": true
                }
            ]
        }
    },

    components: {
        // 'v-mots-clefs': MotsClefs
    },

    mounted: function() {
        mapboxgl.accessToken = 'pk.eyJ1Ijoia2V2aW5kb25ub3QiLCJhIjoiY2lqMXFxYWw1MDA1MnYwbTBhZTU3dzJwcCJ9.5YjSZJWqnt_ui1laEZhrzQ';
        map = new mapboxgl.Map({
            container: 'carte',
            //style: 'mapbox://styles/kevindonnot/clpseux3m019f01o9gxq5h9nl', //new
            style: 'mapbox://styles/kevindonnot/cktb8f7aw5rv418ntcaid1rpo',
            center: [0, 35.024],
            //zoom: 5.5,
            zoom: 1.75,
            interactive : true,
            renderWorldCopies: false
        });
        map.scrollZoom.enable();
        //map.addControl(new mapboxgl.NavigationControl());

        if (this.fiches.length > 0) { // CREER LES MARQUEURS SI LES FICHES SONT DÉJÀ CHARGÉES
            this.creer_marqueurs();
            this.compter_projets_categories();
        }
    },
    watch: {
        fiches: function() {
            this.$nextTick(() => { // ATTENDRE QUE LES DONNÉES AIENT ÉTÉ REPORTÉES SUR LE DOM
                this.creer_marqueurs();
                this.compter_projets_categories();
            });
        }
    },
    methods: {
        creer_marqueurs() {
            if (marqueurs.length < 1) {
                for (var i = 0; i < this.fiches.length; i++) {
                    let fiche = this.fiches[i];
                    //console.log(fiche.slug, fiche.positions);
                    for (var j = 0; j < fiche.positions.length; j++) {
                        let position = fiche.positions[j];
                        if (position[0] != 0) {
                            this.creer_marqueur(fiche.slug, fiche.categorie, position, fiche.titre);
                        }
                    }
                }
            }
            // console.log(marqueurs);
        },

        creer_marqueur(slug, categorie, position, name) {
            const element = document.createElement('div');
            element.className = "marqueur " + convert_to_snake_case(categorie);
            element.setAttribute("data-name",name);

            element.addEventListener("mouseenter", (e) => {
                console.log(element.style.transform);
                var targ = document.getElementById("map-caption-box");
                targ.innerHTML = element.getAttribute("data-name");
                /*targ.style.transform = element.style.transform;
                targ.style.left = (39*4) + "px";*/
                targ.style.transform = "translateX("+ (e.clientX - 39 ) + "px) translateY(" + (e.clientY + 0) + "px)";
                //targ.style.top = e.clientY + 19 + "px";
                targ.classList.add("caption-visible");
                console.log(targ);
            });
            element.addEventListener("mousemove", (e) => {
                console.log(element.style.transform);
                var targ = document.getElementById("map-caption-box");
                targ.style.transform = "translateX("+ (e.clientX - 39 ) + "px) translateY(" + (e.clientY + 0) + "px)";
                console.log(targ);
            });
            element.addEventListener("mouseleave", () => {
                var targ = document.getElementById("map-caption-box");
                targ.classList.remove("caption-visible");
                targ.innerHTML = "";
            });
            element.addEventListener("click", () => {
                this.$router.push(url_base+'localisations/' + slug);
            });

            const marker = new mapboxgl.Marker({
                    element: element,
                    anchor: "center"
                }).setLngLat([position[1], position[0]])
                .addTo(map);

            marqueurs.push(marker);

        },

        compter_projets_categories() {
            for (var i = 0; i < this.fiches.length; i++) {
                let fiche = this.fiches[i];
                if (fiche.categorie != null) {
                    let cat = convert_to_snake_case(fiche.categorie);
                    // console.log(cat);
                    // alert(fiche.categorie);
                    for (var j = 0; j < this.categories.length; j++) {
                        if (this.categories[j].slug == cat) {
                            this.categories[j].nombre++;
                            break;
                        }
                    }
                }
            }
        },

        filtrer(categorie) {

            // MENU ET DONNÉES
            var reinitialiser = false;

            for (var i = 0; i < this.categories.length; i++) {
                if (this.categories[i].slug == categorie) {
                    if (this.categories[i].actif == true) {
                        if (this.toutes_categories_affichees == false) {
                            reinitialiser = true
                        }
                    }
                    break;
                }
            }

            if (reinitialiser) {
                // alert("reini")
                for (var i = 0; i < this.categories.length; i++) {
                    this.categories[i].actif = true;
                    this.toutes_categories_affichees = true;
                }
            } else {
                for (var i = 0; i < this.categories.length; i++) {
                    if (this.categories[i].slug == categorie) {
                        this.categories[i].actif = true;
                    } else {
                        this.categories[i].actif = false;
                    }
                }
                this.toutes_categories_affichees = false
            }

            // EFFET SUR LES MARQUEURS

            var marqueurs = document.querySelectorAll(".marqueur");
            marqueurs.forEach(function(marqueur) {
                marqueur.classList.remove("marqueur_inactif");
            });

            for (var j = 0; j < this.categories.length; j++) {
                let slug = this.categories[j].slug;

                if (this.categories[j].actif == false) {
                    var marqueurs = document.querySelectorAll(".marqueur." + slug);
                    // var marqueurs = document.querySelectorAll("." + slug);
    
                    marqueurs.forEach(function(marqueur) {
                        console.log(marqueur.classList);
                        marqueur.classList.add("marqueur_inactif");
                    });
                } 
                // else {
                //     var marqueurs = document.querySelectorAll(".marqueur." + slug);
                //     marqueurs.forEach(function(marqueur) {
                //         marqueur.classList.remove("marqueur_inactif");
                //     });
                // }
            }


            // for (var i=0; i<marqueurs.length; i++) {
            //     let marqueur = marqueurs[i];
            //     for (var j=0; j<this.categories.length; j++) {
            //         let slug = this.categories[j].slug;
            //         let actif = this.categories[j].actif;

            //         if (actif) {
            //             if (marqueur.element.className.indexOf(slug) >= 0) {
            //                 console.log(slug+ "/ "+marqueur.element.className);
            //             } 
            //         }
            //     }
            // }
        }
    }
};

function convert_to_snake_case(string) {
    return string.charAt(0).toLowerCase() + string.slice(1) // lowercase the first character
        .replace(/\W+/g, " ") // Remove all excess white space and replace & , . etc.
        .replace(/([a-z])([A-Z])([a-z])/g, "$1 $2$3") // Put a space at the position of a camelCase -> camel Case
        .split(/\B(?=[A-Z]{2,})/) // Now split the multi-uppercases customerID -> customer,ID
        .join(' ') // And join back with spaces.
        .split(' ') // Split all the spaces again, this time we're fully converted
        .join('_') // And finally snake_case things up
        .toLowerCase() // With a nice lower case
}
</script>
<style>
.localisations {
    background-color: var(--couleur-localisations);
}
#localisations.replie{
    cursor: pointer;
}
#localisations.replie *{
    pointer-events: none;
}
.contour_texte_carte {
    text-shadow:
        -2px -2px 0 var(--couleur-localisations),
        2px -2px 0 var(--couleur-localisations),
        -2px 2px 0 var(--couleur-localisations),
        2px 2px 0 var(--couleur-localisations);
}

.legendes {
    position: absolute;
    /*border:1px solid red;*/
    top: 0px;
    left: 250px;
    right: 0px;
    z-index: 3;
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 6px;
    padding-right: 10px;
    background-color: var(--couleur-localisations);
    display: flex;
    justify-content: space-between;
    font-size: var(--corps-petit);
    line-height: var(--interlignage-petit);
}

.legende {
    /*border: 1px solid red;*/
    cursor: pointer;
}

.legende>span {
    text-transform: uppercase;
    display: inline-block;
    margin-left: 10px;
}

#carte {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    pointer-events: all;
}

.marqueur,
.marqueur_legende {
    position: absolute;
    z-index: 2;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
}

.marqueur_legende {
    position: relative;
    float: left;
}

.marqueur_inactif {
    background-color: red;
    display:none;
}

.marqueur{
    z-index: 1;
}
.marqueur:hover{
    /*background-color: red;*/
    /*filter: invert(100%);*/
}
.marqueur:hover:after{
    /*content: attr(data-name);
    margin-left: calc(-10px);
    margin-top: -30px;
    background-color: white;
    box-shadow: 0 0 0 1px black;
    padding: 4px;
    font-family: var(--font-family);
    font-size: var(--corps-courant);
    line-height: var(--interlignage-courant);
    z-index: 200;
    position: absolute;
    pointer-events: none;*/
}
#map-caption-box{
    margin-left: calc(-10px);
    margin-top: -30px;
    background-color: white;
    box-shadow: 0 0 0 1px black;
    padding: 4px;
    font-family: var(--font-family);
    font-size: var(--corps-courant);
    line-height: var(--interlignage-courant);
    z-index: 200;
    position: fixed;
    pointer-events: none;
    display: none;
}
#map-caption-box.caption-visible{
    display: block;
}

.marqueur.transformation_spatiale {
    background-image: url("../../assets/images/losange.svg");
}

.marqueur_legende.transformation_spatiale {
    background-image: url("../../assets/images/losange_legende.svg");
}

.legende:hover>.marqueur_legende.transformation_spatiale,
.filtre_actif>.marqueur_legende.transformation_spatiale,
.marqueur.transformations_spatiales:hover {
    background-image: url("../../assets/images/losange_hover.svg");
}

.marqueur.action_sociale_et_artistique {
    background-image: url("../../assets/images/cercle.svg");
}

.marqueur_legende.action_sociale_et_artistique {
    background-image: url("../../assets/images/cercle_legende.svg");
}

.legende:hover>.marqueur_legende.action_sociale_et_artistique,
.filtre_actif>.marqueur_legende.action_sociale_et_artistique,
.marqueur.action_sociale_et_artistique:hover {
    background-image: url("../../assets/images/cercle_hover.svg");
}

.marqueur.exp_rience_p_dagogique {
    background-image: url("../../assets/images/carre.svg");
}

.marqueur_legende.exp_rience_p_dagogique {
    background-image: url("../../assets/images/carre_legende.svg");
}

.legende:hover>.marqueur_legende.exp_rience_p_dagogique,
.filtre_actif>.marqueur_legende.exp_rience_p_dagogique,
.marqueur.exp_rience_p_dagogique:hover {
    background-image: url("../../assets/images/carre_hover.svg");
}

.marqueur.recherche_et_publication {
    background-image: url("../../assets/images/etoile.svg");
}

.marqueur_legende.recherche_et_publication {
    background-image: url("../../assets/images/etoile_legende.svg");
}

.legende:hover>.marqueur_legende.recherche_et_publication,
.filtre_actif>.marqueur_legende.recherche_et_publication,
.marqueur.recherche_et_publication:hover {
    background-image: url("../../assets/images/etoile_hover.svg");
}

.marqueur.plateforme_et_collectif {
    background-image: url("../../assets/images/triangle.svg");
}

.marqueur_legende.plateforme_et_collectif {
    background-image: url("../../assets/images/triangle_legende.svg");
}

.legende:hover>.marqueur_legende.plateforme_et_collectif,
.filtre_actif>.marqueur_legende.plateforme_et_collectif,
.marqueur.plateforme_et_collectif:hover {
    background-image: url("../../assets/images/triangle_hover.svg");
}

.mapboxgl-control-container {
    display: none !important;
}
.mapboxgl-canvas-container{
    height: 100vh;
}

</style>